import React from 'react'
import CouponCommon from 'common/components/entities/Coupon'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CouponInterface } from 'common/types/entities/CouponInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { voidFunc } from 'common/utils/void-function'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { generateBaseEntity } from 'client/utils/createStructureUtils'
import { EntityProps } from 'client/types'


export default function Coupon({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<CouponInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CouponCommon
        {...entity}
        isChecking={false}
        onCodeChange={voidFunc}
        onCheck={voidFunc}
        couponCode=""
      />
    </BaseEntityNew>
  )
}

export const createCoupon = (
  parentId: string,
  placeholder?: string,
  buttonText?: string,
  masterBlockId?: MasterBlockId,
): CouponInterface => ({
  ...generateBaseEntity(EntityTypeEnum.Coupon, parentId, masterBlockId),
  type: EntityTypeEnum.Coupon,
  button: {
    fontSize: 18,
    mobileFontSize: 14,
    text: buttonText ?? '',
    backgroundColor: 'rgba(68,68,68,1)',
    color: 'rgba(255, 255, 255, 1)',
    border: {
      radius: 4,
      style: 'solid',
      color: 'rgba(68,68,68,1)',
      width: 1,
    },
  },
  field: {
    fontSize: 18,
    mobileFontSize: 14,
    placeholder: placeholder ?? '',
    color: 'rgba(68, 68, 68, 1)',
    border: {
      radius: 4,
      style: 'solid',
      color: 'rgba(68,68,68,1)',
      width: 1,
    },
  },
})
